export default {
  "content": "<path stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"4.7\" d=\"M45.965 9.55a2.538 2.538 0 002.663 2.162h23.72a4.198 4.198 0 014.23 4.199v33.715A4.888 4.888 0 0171.97 54.2H16.95a4.888 4.888 0 01-4.606-4.575V7.858a5.389 5.389 0 015.39-5.358H40.01a5.358 5.358 0 015.295 4.575l.659 2.475z\"/><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"4.7\" d=\"M2.943 18.167v32.9A12.533 12.533 0 0015.477 63.6H60.91\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 79 66",
    "width": "79",
    "height": "66",
    "fill": "none"
  }
};